/*
    该文件专门为Count组件生成action对象
*/
import {CLOSE_OPERATE} from '../constant'

//关闭操作面板
export const updateCloseOperate = data => ({type:CLOSE_OPERATE,data})

